import { EmbeddedMessage, MESSAGE_MEDIUMS, WhatsApp } from 'constants/messageMediums';
import { IndexPageTemplate } from 'modules/templateIndex/types';
import { TemplatePreview } from 'modules/templatePreview';
import {
  EmbeddedMessage as EmbeddedMessageIcon,
  SendPush,
  SendSMS,
  SendWebPush,
  WhatsAppLine24,
} from 'ui/icons';
import { LogoColors } from 'ui/logo';
import { colors } from 'ui/theme';

import { PreviewThumbnailsById } from '../hooks/usePreviewThumbnails';
import { ImageWrapper, PreviewImg, StyledLogo } from './../components/TableView.styles';

type MsgMediumIconProps = {
  medium: string;
};

const MessageMediumIcon = ({ medium }: MsgMediumIconProps) => {
  switch (medium) {
    case MESSAGE_MEDIUMS.PUSH.dbKey:
      return <SendPush color={colors.grey25} />;
    case MESSAGE_MEDIUMS.WEB_PUSH.dbKey:
      return <SendWebPush color={colors.grey25} />;
    case EmbeddedMessage:
      return <EmbeddedMessageIcon color={colors.grey25} />;
    case WhatsApp:
      return <WhatsAppLine24 color={colors.grey25} />;

    default:
      return <SendSMS color={colors.grey25} />;
  }
};

type Props = {
  previewThumbnailsById: PreviewThumbnailsById;
  template: IndexPageTemplate;
};

/**
 * Gets the preview image to show as the thumbnail for a template
 */
export const TemplatePreviewImage = ({ template, previewThumbnailsById }: Props) => {
  const { messageMedium, id } = template;
  const triggerPreviewKeys = [MESSAGE_MEDIUMS.EMAIL.dbKey];
  const iframePreviewKeys = [MESSAGE_MEDIUMS.IN_APP.dbKey];
  if (triggerPreviewKeys.includes(messageMedium)) {
    return id in previewThumbnailsById ? (
      <ImageWrapper>
        <PreviewImg alt="preview" src={previewThumbnailsById[id]} />
      </ImageWrapper>
    ) : (
      <ImageWrapper isEmptyState>
        <StyledLogo color={LogoColors.BLACK} height={20} />
      </ImageWrapper>
    );
  }

  if (iframePreviewKeys.includes(messageMedium)) {
    return <TemplatePreview size="thumbnail" templateId={template.id} {...template} />;
  }

  return (
    <ImageWrapper>
      <MessageMediumIcon medium={messageMedium} />
    </ImageWrapper>
  );
};
